module.exports = __webpack_public_path__ + "media/logos/msnbc-logo-white-e664fb18.png";